// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__Uu41T","boxTitle":"Qualiphy_boxTitle__1W9RQ","box":"Qualiphy_box__dljBR","toggleWrap":"Qualiphy_toggleWrap__2p9pa"};